export default function Picture({ picture, altText = "Showcase of project" }) {
  return (
    <div className="showcasePicture">
      <img src={picture} alt={altText} />
    </div>
  );
}
